// extracted by mini-css-extract-plugin
export default {"container":"TangramTable-module__container___OgNrP","example":"TangramTable-module__example___oA6SH","table":"TangramTable-module__table___DCeSo"};